import { Button } from '@design-system/Button';
import type { SMPPaymentMethodV2 } from '@viome/viome-base/src/usecase/SMP/SMP.model';
import {
  formatCardExpiry,
  getBrandDisplayName,
} from '../utils/paymentMethodHelpers';
import { resolveBrandLogo } from './SMPCardBrandLogo';

interface SMPSavedCardTileProps {
  paymentMethod: SMPPaymentMethodV2;
  lastChargeDate?: string;
  /** Starts the Loop hosted-page flow (fetch URL → full-page redirect). */
  onUpdateClick: () => void;
  /** True from the tap until the browser leaves for Loop's page. */
  isUpdating?: boolean;
}

export const SMPSavedCardTile = ({
  paymentMethod,
  lastChargeDate,
  onUpdateClick,
  isUpdating = false,
}: SMPSavedCardTileProps) => {
  const { card } = paymentMethod;
  if (!card) return null;

  const BrandLogo = resolveBrandLogo(card.brand);
  const brandName = getBrandDisplayName(card.brand);
  const expiry = formatCardExpiry(card);

  return (
    <div
      data-testid="smp-savedCardTile"
      className="flex items-center gap-5 rounded-2xl border border-stroke-primary-subtle bg-white p-5"
    >
      <div className="flex h-9 w-14 flex-shrink-0 items-center justify-center rounded-md border border-stroke-primary-subtle bg-white">
        <BrandLogo />
      </div>
      <div className="min-w-0 flex-1 fs-mask">
        <div className="typography-body font-medium text-primary">
          {brandName} ending in {card.lastDigits}
        </div>
        <div className="typography-caption text-tertiary">
          Expires {expiry}
          {lastChargeDate ? ` · last charge ${lastChargeDate}` : ''}
        </div>
      </div>
      <Button
        data-testid="smp-paymentMethods-updateCardBtn"
        variant="secondary"
        onClick={onUpdateClick}
        disabled={isUpdating}
        className="h-9 px-4"
      >
        {isUpdating ? 'Opening...' : 'Update card'}
      </Button>
    </div>
  );
};
